import React from 'react'
import { Link } from "react-router-dom";


const Orthopedic = () => {
  return (
    <>
      <section className="page-title" style={{ backgroundImage: 'url(assets/images/background/3.jpg)' }}>
        <div className="auto-container">
          <h2>Orthopedics</h2>
          <ul className="bread-crumb clearfix">
            <li><Link to="/">Home</Link></li>
            <li style={{ color: "green" }}>Orthopedics</li>
          </ul>
        </div>
      </section>

      <div className="sidebar-page-container left-sidebar" style={{ marginTop: "-100px" }}>
        <div className="auto-container">
          <marquee width="100%" direction="left" height="" ><br/>
            <b className='' style={{fontSize:"18px", color:"green"}}>अन्य सुविधा - ECG | USG | X-Ray | ICU | Ventilator । फामेसर्सी । पैथालॉली</b>
          </marquee>
          <div className="row clearfix">
            <div className="sidebar-side col-lg-4 col-md-12 col-sm-12">
              <aside className="sidebar sticky-top">
                <div className="sidebar-widget department-widget">
                  <div className="widget-content">
                    <ul className="department-list">
                      <li className="active"><Link to="/orthopedic">Orthopedic</Link></li>
                      <li ><Link to="/neurosurgery">Neurosurgery</Link></li>
                      <li ><Link to="/neurology">Neurology</Link></li>
                      <li ><Link to="/gynaecology">Gynaecology</Link></li>
                      <li><Link to="/general-surgery">General Surgery</Link></li>
                      <li><Link to="/general-medicine">General Medicine</Link></li>
                      <li ><Link to="/gastroenterology">Gastroenterology</Link></li>
                      <li><Link to="/paediatrics">Paediatrics</Link></li>
                      <li ><Link to="/neuropsychiatrist">Neuropsychiatrist</Link></li>

                    </ul>
                  </div>
                </div>
                {/* Time Widget */}
                {/* <div className="sidebar-widget time-widget">
                  <div className="widget-content">
                    <div className="time-widget_content">
                      <span className="clock_icon flaticon-clock" />
                      <h4>Working Time</h4>
                      <ul className="working-time_list">
                        <li>Mon-Thu <span>08:00 - 20:00</span></li>
                        <li>Friday <span>07:00 - 22:00</span></li>
                        <li>Saturday <span>08:00 - 18:00</span></li>
                      </ul>
                    </div>
                  </div>
                </div> */}
                {/* Time Widget */}
                <div className="sidebar-widget contact-info_widget">
                  <div className="widget-content">
                    <div className="time-widget_content">
                      <h4>Contact Info</h4>
                      <ul className="contact-info_widget-list">
                        <li><span className="icon fa-solid fa-phone fa-fw" /><Link style={{ color: "black" }} to='https://share.google/fCIHbcmFHPs4QBm5t' target="_blank">सतना स्वास्तिक हॉस्पिटल पन्नीलाल चौक, सतना (म.प्र.)</Link></li>
                        <li><span className="icon fa-solid fa-envelope fa-fw" /> <Link style={{ color: "black" }} to="mailto:satnaswastikhospital@gmail.com">satnaswastikhospital@gmail.com</Link></li>
                        {/* <li><span className="icon fa-solid fa-clock fa-fw" />Mon - Sat 8:00 - 6:30, <br /> Sunday - CLOSED</li> */}
                      </ul>
                    </div>
                  </div>
                </div>
                {/* Expert Widget */}
                <div className="sidebar-widget expert_widget" style={{ backgroundImage: 'url(assets/images/background/pattern-33.png)' }}>
                  <span className="color-layer" />
                  <h3>Experienced Team of Doctors, Nurses, and Staff</h3>
                  <Link to="/appointment" className="theme-btn btn-style-one">
                    <span className="btn-wrap">
                      <span className="text-one">Book Appointment</span>
                      <span className="text-two">Book Appointment</span>
                    </span>
                  </Link>
                  <div className="image">
                    <img src="assets/images/resource/doctor-1.png" alt />
                  </div>
                </div>
              </aside>
            </div>
            {/* Content Side */}
            <div className="content-side col-lg-8 col-md-12 col-sm-12">
              <div className="department-detail">
                <div className="inner-box">
                  <div className="image">
                    <img src="assets/img/Orthopedics.avif" alt />
                  </div>
                  <h3>Orthopedics & Joint Replacement</h3>
                  <p> When necessary, we perform procedures utilizing all medical, physical, and rehabilitative techniques to address the patient's issues with their bones and joints. We do various hip, knee, shoulder, and elbow joint replacement operations. We treat all muscle, ligament, and tendon injuries as well as basic and complex bone fractures. We also treat children's injuries and rectify deformities. Arthritis and other age-related issues are also treated by us.</p>

                  <h3>Conditions we treat</h3>
                  <div className="graph-outer">
                    <div className="row clearfix">
                      <div className="column col-lg-6 col-md-6 col-sm-12">
                        <ul className="list">
                          <li>सभी तरीके के टॉमा फैक्चर जैसे रीढ़ की हड्डी, हाथ, पैर के ऑपरेशन</li>
                          <li>कमर एवं रीढ़ की हड्‌डी का दर्द</li>
                          <li>घुटने दर्द के PRP इंजेक्शन</li>
                          <li>कंधे के दर्द में PRP के एक इंजेक्शन से हमेशा के लिए आराम</li>
                          <li>एड़ी के दर्द में PRP के एक इंजेक्शन से हमेशा के लिए आराम</li>
                          <li> घुटनों में दर्द एवं सूजन</li>
                          <li> कंधे में दर्द एवं जकड़न</li>
                          <li> सामान्य एवं जटिल फ्रेक्चर</li>
                          <li> हड्डी में इंफेक्शन</li>
                          <li> चलने में लड़खड़ाना</li>
                        </ul>
                      </div>
                      <div className="column col-lg-6 col-md-6 col-sm-12">
                        <ul className="list">
                          <li>ईलिजारोब पद्धति द्वारा हड्डियों का इलाज</li>
                          <li>अत्याधुनिक तकनीक द्वारा जोड़ प्रत्यारोपण (JOINT REPLACEMENT)</li>
                          <li>कुल्हे एवं घुटने का दर्द</li>
                          <li>समस्त प्रकार के जोड़ों से संबंधित रोग</li>
                          <li>घुटनों में पानी भरना</li>
                          <li> कंधे में मांस का फटना</li>
                          <li> पुराने फ्रेक्चर का न जुड़ना</li>
                          <li> लिंगमेंट में संबंधित समस्याऐं</li>
                          <li> बच्चों के पैरों की विकृतियाँ</li>
                          <li>  अत्याधुनिक दूरबीन पद्धति द्वारा कम चींड-फाड़ में घुटनें, कंधे एवं रीढ़ की हड्डी के ऑपरेशन</li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <h3>Specialists</h3>
                  <div className=" col-lg-6 col-md-12 col-sm-12">
                    <div className="inner-box wow fadeInLeft animated" data-wow-delay="450ms" data-wow-duration="1500ms" style={{ visibility: 'visible', animationDuration: '1500ms', animationDelay: '450ms', animationName: 'fadeInLeft' }}>
                      <div className="image">
                        <img src="assets/img/Dr. Mulayam Singh Yadav.webp" alt style={{ width: "200px", height: "200px", borderRadius: "100px" }} />
                      </div>
                      <div className="lower-content">
                        <div className="content">
                          <h5 style={{ textAlign: "justify", marginTop: "-22px" }}><a to="#" style={{ textAlign: "center" }}>Dr. Mulayam Singh Yadav</a></h5>
                          <div className="designation" style={{ textAlign: "justify" }}>( Gold Medalist)
                            MBBS, MS Orthopedic, D.Ortho</div>


                        </div>
                        {/* <a to="#" className="plus-box flaticon-plus" /> */}
                      </div>
                    </div>
                  </div>
                  {/* <div className="image">
                    <img src="assets/img/Dr. Divyant Gupta.webp" alt style={{width:"200px", height:"200px", borderRadius:"100px"}} />
                  </div>
                  <p><strong>Electrocardiogram (ECG or EKG): </strong>this records the electrical activity of the heart.</p> */}

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>




    </>
  )
}

export default Orthopedic